module.exports = __webpack_public_path__ + "media/images/twitter-afa881f6cdeea22de9ba76009f66401f.png";